/**
 * i18n Configuration for Web Dashboard
 * Uses @hyb/i18n for Single Source of Truth translations
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources, fallbackLng, defaultNS, supportedLngs } from '@hyb/i18n';

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'th', // Default to Thai
        fallbackLng,
        defaultNS,
        supportedLngs,
        interpolation: {
            escapeValue: false, // React already escapes
        },
        react: {
            useSuspense: false,
        },
    });

export default i18n;
